export default "__VITE_ASSET__DxJ0zfcU__"